module.exports = __webpack_public_path__ + "img/portraits_30_H.482993a1.webp";